import { useQuery } from '@tanstack/react-query';
import { useInjection } from 'inversify-react';
import { InviteService } from '../services/invite/invite.service';
import type { IInviteService } from '../services/invite/invite.service.interface';

const inviteQueryKeys = {
  detail: (token: string, tenantId: string) => ['invite', token, tenantId] as const,
};

export function useInviteDetails(token: string | undefined, tenantId: string | undefined) {
  const service = useInjection<IInviteService>(InviteService);

  return useQuery({
    queryKey: inviteQueryKeys.detail(token ?? '', tenantId ?? ''),
    queryFn: () => service.getByToken(token ?? '', tenantId ?? ''),
    enabled: !!token && !!tenantId,
    retry: false,
  });
}
